export function maskPhone(phone: string, unmaskedHead = 5, unmaskedTail = 3) {
    const chars = phone.split('');

    let maskedCount = 0;
    for (let i = unmaskedHead; i < chars.length; i++) {
        const isDigit = /\d/.test(chars[i]);
        if (isDigit) {
            chars[i] = '*';
            maskedCount += 1;
        }
        if (maskedCount > phone.length - (unmaskedTail + unmaskedHead)) {
            break;
        }
    }
    return chars.join('');
}
